App.StoryFrameCardComponent = Em.Component.extend
  classNames: ['story-frame-card']

  storyFrame: null

  cardBackgroundStyle: (->
    photo = @get('storyFrame.photo.original')
    result = if photo then "background-image:  url(#{photo});" else ''
    result.htmlSafe()
  ).property('storyFrame.photo.original')


  showPhotoCard: (->
    frame = @get('storyFrame')
    @get('cardBackgroundStyle') and frame.frame_variant is 'image'
  ).property('cardBackgroundStyle', 'storyFrame.frame_variant')

  cardBackgroundColorStyle: (->
    color = @get('storyFrame.background_color')
    result = if color then "background-color:  #{color}" else ''
    result.htmlSafe()
  ).property('storyFrame.photo.original')

  click: () ->
    @sendAction('action', @get('storyFrame'))
    false

